const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const GoogleLinkedApp = () => import(/* webpackChunkName: "google" */ '@/modules/google/view/linkedapp.vue');
const GooglePayment = () => import(/* webpackChunkName: "google" */ '@/modules/google/view/payment.vue');

export const ROUTE_NAME_GOOGLE = {
    PAYMENT: 'GooglePayment',
    LINKED_APP: 'GoogleLinkedApp'
} as const;

export default [
    {
        path: '/app/:appId/google',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'payment',
                name: ROUTE_NAME_GOOGLE.PAYMENT,
                component: GooglePayment,
                meta: { requiresAuth: true }
            },
            {
                path: 'linkedapp',
                name: ROUTE_NAME_GOOGLE.LINKED_APP,
                component: GoogleLinkedApp,
                meta: { requiresAuth: true }
            }
        ]
    }
];
